const formatoComas = (value: string): string => {

    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join('.');

};

const soloNumeros = (text: string, esDecimal: boolean = false): string => {

    let ascii: number[] = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

    if (esDecimal) ascii.push(46)

    let value: string = "";

    if (text.split(".").length === 3) return text.slice(0, -1);
    if (
        text.split(".").length === 2 &&
        text.split(".")[1].length > 2 &&
        ascii.includes(text.split(".")[1][0].charCodeAt(0)) &&
        ascii.includes(text.split(".")[1][1].charCodeAt(0))
    ) return text.slice(0, -1);

    value = text.split('').filter(letter => ascii.includes(letter.charCodeAt(0))).join('');

    value = value.length === 0 ? "0" : value;

    value = value.replace(/^0+(?=\d)/, '');

    return value;

};

const formatPhoneNumber = (phoneNumber: string): string => {

    const cleaned = phoneNumber.replace(/\D/g, '');
    
    const parts = [
        cleaned.slice(0, 3),
        cleaned.slice(3, 6),
        cleaned.slice(6, 8),
        cleaned.slice(8, 10),
    ];
    const formatted = parts.filter(Boolean).join('-');

    return formatted;

};

const Numero = {
    soloNumeros,
    formatoComas,
    formatPhoneNumber
};

export default Numero